export default __webpack_public_path__ + "static/media/signin.dfff6674.png";